define("shared/components/shared/post/secondary/hashtag-suggestions/paid-upgrade-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <section class="o--modalBody--secondary u--p__0 has--footer">
    {{! Upgrade }}
    <div class="cMH--blank">
      <Shared::Post::Secondary::HashtagSuggestions::UpgradeModalBackground />
      <div class="cMH--blank__overlay is--centered">
        <div class="u--p">
          <p class="u--text--bold u--text--md u--text--center u--m__b__xs">
            {{@upgradeTitle}}
          </p>
          <p class="u--text--light u--text--center u--m__b__0">
            {{@upgradeDescription}}
            {{#unless this.isMobileSubscription}}
              <Shared::Link
                @href={{@href}}
                @text={{t "shared_phrases.learn_more"}}
                title={{t "hashtag_suggestions.upsell.title"}}
              />
            {{/unless}}
          </p>
  
          {{#if this.isMobileSubscription}}
            <p class="u--text--center u--m__t__xs">
              <Shared::Ui::Button
                @class="u--p__0 u--text--hl"
                @text={{t "plans.mobile.learn_how"}}
                @variant="unstyled"
                onClick={{this.openMobileRedirectModal}}
              />
            </p>
          {{/if}}
        </div>
      </div>
    </div>
  </section>
  */
  {
    "id": "Q92m0Z+w",
    "block": "[[[10,\"section\"],[14,0,\"o--modalBody--secondary u--p__0 has--footer\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"cMH--blank\"],[12],[1,\"\\n    \"],[8,[39,0],null,null,null],[1,\"\\n    \"],[10,0],[14,0,\"cMH--blank__overlay is--centered\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--p\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold u--text--md u--text--center u--m__b__xs\"],[12],[1,\"\\n          \"],[1,[30,1]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--text--center u--m__b__0\"],[12],[1,\"\\n          \"],[1,[30,2]],[1,\"\\n\"],[41,[51,[30,0,[\"isMobileSubscription\"]]],[[[1,\"            \"],[8,[39,2],[[16,\"title\",[28,[37,3],[\"hashtag_suggestions.upsell.title\"],null]]],[[\"@href\",\"@text\"],[[30,3],[28,[37,3],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isMobileSubscription\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--center u--m__t__xs\"],[12],[1,\"\\n            \"],[8,[39,5],[[16,\"onClick\",[30,0,[\"openMobileRedirectModal\"]]]],[[\"@class\",\"@text\",\"@variant\"],[\"u--p__0 u--text--hl\",[28,[37,3],[\"plans.mobile.learn_how\"],null],\"unstyled\"]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@upgradeTitle\",\"@upgradeDescription\",\"@href\"],false,[\"shared/post/secondary/hashtag-suggestions/upgrade-modal-background\",\"unless\",\"shared/link\",\"t\",\"if\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/paid-upgrade-modal.hbs",
    "isStrictMode": false
  });
  let PaidUpgradeModalComponent = _exports.default = (_class = class PaidUpgradeModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "subscriptions", _descriptor, this);
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    openMobileRedirectModal() {
      this.subscriptions.openMobileRedirectModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openMobileRedirectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMobileRedirectModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PaidUpgradeModalComponent);
});